import styled from 'styled-components';


export const Container = styled.div`

    width:100%;
    height: 150px;

    background-color: black;
    color: #ffffff;
    font-size: 12px;



    display: flex;
    align-items: center;
    justify-content: space-around;

    a{
        text-decoration: none;
        color: #ffffff;

    }

    .FIIcon{
        margin: 0 10px
    }

    #ContainerFIIcon{
        display: flex;
        align-items: center;


        p:first-child{
            margin-top: 10px;
        }



        #right{


            display: flex;
            flex-direction: column;

            a{

                background-color: #f85d00;
                color: black;
                padding: 8px;
                border-radius: 5px;
                margin-left:8px; 
            }

            div#footer{
                display: flex;
                align-items: center;
                justify-items: space-between;





                p{

                }
                a{

                }
            }
        }


    }


`
